import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import useCierrePorInactividad from "hooks/useCierrePorInactividad";

export default function ProtectedRoute({ children }) {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  // Acá porque envuelve todo lo autenticado: una sola instancia del vigilante,
  // viva mientras haya sesión y apagada cuando no.
  useCierrePorInactividad(Boolean(user), logout);

  if (loading) {
    return (
      <div className="flex min-h-screen w-full items-center justify-center bg-lightPrimary dark:bg-navy-900">
        <p className="text-sm text-navy-700 dark:text-white">Cargando…</p>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate to="/auth/sign-in" replace state={{ from: location.pathname }} />
    );
  }

  return children;
}
